
<template>
  <div class="container">
    <h1>
        {{msg}}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'PannelMessage',
  components: {},
  props: {
    // soft: String,
  },
  data () {
    return {
      visible: true,
      msg: '留言逻辑开发中，暂不可用...',
    }
  },

  mounted()
  {
    // this.soft = this.$route.params.soft;
  },
  created()
  {
    // this.soft = this.$route.query.id;
    // this.$router.push({ path: '/soft', query: { id: 'easyicon' }});

    // this.soft = this.$route.params.id;
    // this.$router.push({ name: '/soft', params: { id: 'easyicon' }});
    

    // var that = this;
    // // this.$http.get('http://localhost:44923/pages/NoteInfo.aspx?soft=easyicon')
    // this.$http.get('/pages/NoteInfo.aspx', {params:{soft: this.soft}})
    // .then((response)=>{
    //   // console.log(response);
    // })
    // .catch((response)=>{
    //     console.log(response);
    // })

  },

  methods: {
    
    // // string转为base64
    // stringToBase64(str) {
    //   return new Buffer.from(str).toString("base64");
    // },

    // // base64转字符串
    // base64ToString(b64) {
    //   return new Buffer.from(b64, "base64").toString();
    // },

  }

}
</script>

<style scoped>

#page-detail {
    width: 60%;
    min-width: 810px;
    margin: 0 auto;
}

.content p {
    word-wrap: break-word;
}

a:hover {
    background-color: rgb(233,104,107);
}

</style>


// WEBPACK FOOTER //
// src/components/PannelMessage.vue